import styled from 'styled-components';
import { FONT_SIZE, FONT_WEIGHT, media } from '@app/styles/themes/constants';
import { themeObject } from '@app/styles/themes/themeVariables';

export const LoginDescription = styled.div`
  margin-bottom: 1.875rem;
  color: ${themeObject.light.textMain};
  font-size: ${FONT_SIZE.xs};

  @media only screen and ${media.xs} {
    margin-bottom: 1.5625rem;
    font-weight: ${FONT_WEIGHT.bold};
  }

  @media only screen and ${media.md} {
    margin-bottom: 1.75rem;
    font-weight: ${FONT_WEIGHT.regular};
  }

  @media only screen and ${media.xl} {
    margin-bottom: 1.875rem;
  }
`;

export const RememberMeText = styled.span`
  color: var(--primary-color);
  font-size: ${FONT_SIZE.xs};
`;

export const ForgotPasswordText = styled.span`
  color: ${themeObject.light.textMain};
  font-size: ${FONT_SIZE.xs};
  text-decoration: underline;
`;

export const SSOWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.5rem;
  gap: 0.75rem;
`;

export const SSOLabel = styled.span`
  color: ${themeObject.light.textMain};
  font-size: ${FONT_SIZE.xs};
  font-weight: ${FONT_WEIGHT.regular};
`;

export const SSOButton = styled.button`
  color: ${themeObject.light.primary};
  background: transparent;
  border: 1px solid ${themeObject.light.primary};
  border-radius: 4px;
  padding: 0.5rem 2rem;
  font-size: ${FONT_SIZE.md};
  font-weight: ${FONT_WEIGHT.semibold};
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  
  &:hover {
    background: ${themeObject.light.primary};
    color: ${themeObject.light.background};
  }
`;
